import './polyfills/promiseWithResolvers'
import './preloadFonts'
import './initialiseFirebase'
import 'react-pdf/dist/Page/TextLayer.css'
import 'react-pdf/dist/Page/AnnotationLayer.css'
import { BrowserRouter as Router } from 'react-router-dom'
import CssBaseline from '@mui/material/CssBaseline'
import { createRoot } from 'react-dom/client'
import { ReduxProvider } from './redux/ReduxProvider'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { SnackbarProvider } from './components/providers/SnackbarProvider'
import { OnboardingProvider } from './components/providers/OnboardingProvider'
import { TemplateDialogProvider } from './components/providers/TemplateDialogProvider'
import { CompanyPlanningRecordDialogProvider } from './components/providers/CompanyPlanningRecordDialogProvider'
import { PlanningRecordDialogProvider } from './components/providers/PlanningRecordDialogProvider'
import { PostcodeDistrictsDialogProvider } from './components/providers/PostcodeDistrictsDialogProvider'
import { FiltersDialogProvider } from './components/providers/FiltersDialogProvider'
import { SubscriptionDialogProvider } from './components/providers/SubscriptionDialogProvider'
import { EditTemplateDialogProvider } from './components/providers/EditTemplateDialogProvider'
import { CompanyPaymentsDialogProvider } from './components/providers/CompanyPaymentsDialogProvider'
import { ThemeProvider } from '@mui/material/styles'
import { theme } from './theme'
import { pdfjs } from 'react-pdf'
import { ActiveTemplateProvider } from './components/providers/ActiveTemplateProvider'
import { CompanyPlanningRecordLettersProvider } from './components/providers/CompanyPlanningRecordLettersProvider'
import { CompanyPaymentsProvider } from './components/providers/CompanyPaymentsProvider'
import { CompanyCardsProvider } from './components/providers/CompanyCardsProvider'
import { PlanningRecordsProvider } from './components/providers/PlanningRecordsProvider'
import Bootstrap from './Bootstrap'

pdfjs.GlobalWorkerOptions.workerSrc = process.env.PUBLIC_URL + '/pdf.worker.mjs'

const container = document.getElementById('root')!
const root = createRoot(container)
root.render(
  <>
    <CssBaseline />
    <ReduxProvider>
      <ThemeProvider theme={theme}>
        <SnackbarProvider>
          <ActiveTemplateProvider>
            <CompanyPlanningRecordLettersProvider>
              <CompanyPaymentsProvider>
                <CompanyCardsProvider>
                  <PlanningRecordsProvider>
                    <Bootstrap />
                    <Router>
                      <OnboardingProvider>
                        <EditTemplateDialogProvider>
                          <TemplateDialogProvider>
                            <FiltersDialogProvider>
                              <SubscriptionDialogProvider>
                                <CompanyPaymentsDialogProvider>
                                  <PostcodeDistrictsDialogProvider>
                                    <CompanyPlanningRecordDialogProvider>
                                      <PlanningRecordDialogProvider>
                                        <App />
                                      </PlanningRecordDialogProvider>
                                    </CompanyPlanningRecordDialogProvider>
                                  </PostcodeDistrictsDialogProvider>
                                </CompanyPaymentsDialogProvider>
                              </SubscriptionDialogProvider>
                            </FiltersDialogProvider>
                          </TemplateDialogProvider>
                        </EditTemplateDialogProvider>
                      </OnboardingProvider>
                    </Router>
                  </PlanningRecordsProvider>
                </CompanyCardsProvider>
              </CompanyPaymentsProvider>
            </CompanyPlanningRecordLettersProvider>
          </ActiveTemplateProvider>
        </SnackbarProvider>
      </ThemeProvider>
    </ReduxProvider>
  </>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
